import React from 'react'
import PropTypes from 'prop-types'
import './header.scss'

const Header = ({ title, description }) => (
  <div className="carousel-header">
    {title && title.length
    && <h2 className="carousel-header__common carousel-header__title title-wysiwyg" dangerouslySetInnerHTML={{ __html: title }} />
    }

    {description && description.length
      && (
      <div
        className="carousel-header__common carousel-header__description"
        dangerouslySetInnerHTML={{ __html: description }}
      />
      )
    }
  </div>
)

Header.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
}

Header.defaultProps = {
  title: '',
  description: '',
}

export default Header
